import Icon from 'veui/components/Icon'

Icon.register({
  home: {
    paths: [
      {
        d: 'M36 42a2 2 0 002-2V24c0-1.1.9-2 2-2h.83L24 6.7 7.17 22H8a2 2 0 012 2v16c0 1.1.9 2 2 2h5v-8a4 4 0 014-4h6a4 4 0 014 4v8h5zm6-16v14a6 6 0 01-6 6h-7a2 2 0 01-2-2V34h-6v10a2 2 0 01-2 2h-7a6 6 0 01-6-6V26H2a2 2 0 01-1.35-3.48L21.31 3.74a4 4 0 015.38 0l20.66 18.78A2 2 0 0146 26h-4z'
      }
    ],
    width: '48',
    height: '48'
  }
})
